const formConfig = {
  1: {
    formFields: [
      {
        name: "name",
        type: "text",
        label: "Full Name",
        placeholder: "Enter your name",
        required: true,
      },
      {
        name: "email",
        type: "email",
        label: "Email Address",
        placeholder: "Enter your email",
        required: true,
      },
      {
        name: "phone",
        type: "tel",
        label: "Phone Number",
        placeholder: "Enter your phone number",
        required: false,
      },
      {
        name: "teamMembers",
        type: "number",
        label: "Team Members",
        placeholder: "Enter the number of members",
        required: true,
      },
      {
        name: "category",
        type: "select",
        label: "Category",
        options: ["Junior", "Senior", "Professional"],
        required: true,
      },
    ],
  },
  2: {
    formFields: [
      {
        name: "name",
        type: "text",
        label: "Your Name",
        placeholder: "Enter your name",
        required: true,
      },
      {
        name: "github",
        type: "url",
        label: "GitHub Profile",
        placeholder: "Enter GitHub URL",
        required: true,
      },
    ],
  },
  3: {
    formFields: [
      {
        name: "name",
        type: "text",
        label: "Your Name",
        placeholder: "Enter your name",
        required: true,
      },
      {
        name: "github",
        type: "url",
        label: "GitHub Profile",
        placeholder: "Enter GitHub URL",
        required: true,
      },
    ],
  },
  4: {
    formFields: [
      {
        name: "name",
        type: "text",
        label: "Full Name",
        placeholder: "Enter your name",
        required: true,
      },
      {
        name: "email",
        type: "email",
        label: "Email Address",
        placeholder: "Enter your email",
        required: true,
      },
      {
        name: "phone",
        type: "tel",
        label: "Phone Number",
        placeholder: "Enter your phone number",
        required: false,
      },
      {
        name: "teamMembers",
        type: "number",
        label: "Team Members",
        placeholder: "Enter the number of members",
        required: true,
      },
      {
        name: "category",
        type: "select",
        label: "Category",
        options: ["Junior", "Senior", "Professional"],
        required: true,
      },
    ],
  },
  5: {
    formFields: [
      {
        name: "name",
        type: "text",
        label: "Full Name",
        placeholder: "Enter your name",
        required: true,
      },
      {
        name: "email",
        type: "email",
        label: "Email Address",
        placeholder: "Enter your email",
        required: true,
      },
      {
        name: "phone",
        type: "tel",
        label: "Phone Number",
        placeholder: "Enter your phone number",
        required: false,
      },
      {
        name: "teamMembers",
        type: "number",
        label: "Team Members",
        placeholder: "Enter the number of members",
        required: true,
      },
      {
        name: "category",
        type: "select",
        label: "Category",
        options: ["Junior", "Senior", "Professional"],
        required: true,
      },
    ],
  },
  6: {
    formFields: [
      {
        name: "name",
        type: "text",
        label: "Full Name",
        placeholder: "Enter your name",
        required: true,
      },
      {
        name: "email",
        type: "email",
        label: "Email Address",
        placeholder: "Enter your email",
        required: true,
      },
      {
        name: "phone",
        type: "tel",
        label: "Phone Number",
        placeholder: "Enter your phone number",
        required: false,
      },
      {
        name: "teamMembers",
        type: "number",
        label: "Team Members",
        placeholder: "Enter the number of members",
        required: true,
      },
      {
        name: "category",
        type: "select",
        label: "Category",
        options: ["Junior", "Senior", "Professional"],
        required: true,
      },
    ],
  },
};

export default formConfig;
